import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { FontIconComponent } from '@camelot/icons';
import { ExpandableTextComponent } from '@camelot/ui';

import { ItemType } from '../../../../../common/services/dto/item-type';
import { BillingRow } from '../../../../../common/services/dto/row';
import { RowType } from '../../../../../common/services/dto/row-type';
import { ItemTypeStatusComponent } from '../../item-type-status/item-type-status.component';

@Component({
  host: { 'data-cid': 'grid-billing-name-cell' },
  imports: [ExpandableTextComponent, FontIconComponent, ItemTypeStatusComponent],
  selector: '',
  template: `@if (!this.isComment) {
      <div class="flex-row g-space-md">
        {{ this.value }}
        <cam-billings-item-type-status [type]="this.itemType"></cam-billings-item-type-status>
      </div>
    }
    @if (this.isComment) {
      <div class="align-center g-space-md">
        <cam-font-icon name="infos" type="sm"></cam-font-icon>
        <cam-expandable-text>
          <div class="fs-font-body-sm-default-size">
            {{ this.value }}
          </div>
        </cam-expandable-text>
      </div>
    }`,
})
export class GridBillingNameCellComponent extends AbstractCellComponent<BillingRow, string> {
  get isComment() {
    return this._item?.rowType === RowType.Comment;
  }
  get itemType() {
    return this._item?.itemType || ItemType.Unknown;
  }
}
